'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notifier = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _notification = require('antd/lib/notification');

var _notification2 = _interopRequireDefault(_notification);

var _copyLogger = require('./copyLogger');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// 默认8秒
_notification2.default.config({
  duration: 8
});
// 默认4秒
_message2.default.config({
  duration: 4
});

var seniorNotification = Object.assign({}, _notification2.default);
['success', 'info', 'warning', 'error', 'warn'].forEach(function (type) {
  seniorNotification[type] = function (args) {
    return _notification2.default[type](assign({}, args, { type: type, duration: null }));
  };
});

var Notifier = exports.Notifier = (_temp = _class = function () {
  function Notifier() {
    var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var immediate = arguments[1];

    _classCallCheck(this, Notifier);

    this.$opt_ = opt;
    if (immediate) {
      this.notify(opt);
    }
  }

  _createClass(Notifier, [{
    key: 'notify',
    value: function notify(opt) {
      var _this = this;

      var strategy = Notifier.strategy;
      // 特殊处理
      if (opt.rid) {
        opt = {
          content: opt
        };
      }
      opt = Object.assign({ type: 'info', level: 'one' }, this.$opt_, opt);

      if (opt.trace) {
        delete this.$opt_.trace;
        delete opt.trace;
        if (opt.content.then) {
          opt.content.then(function (res) {
            if (Object(res) !== res) {
              res = {
                message: res
              };
            }
            var rid = opt.rid || res.rid;
            if (rid) {
              opt.content = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  res.message
                ),
                _react2.default.createElement(_copyLogger.CopyLogger, { rid: rid, message: 'rid: ' + rid })
              );
            } else {
              opt.content = res.message;
            }
            _this.notify(opt);
          }, function (err) {
            opt.content = err.message;
            _this.notify(opt);
          });
        } else {
          if (Object(opt.content) === opt.content) {
            var rid = opt.rid || opt.content.rid;
            var content = opt.content.message;
            if (rid) {
              opt.content = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  content
                ),
                _react2.default.createElement(_copyLogger.CopyLogger, { rid: rid, message: 'rid: ' + rid })
              );
            } else {
              opt.content = content;
            }
          }
          this.notify(opt);
        }
      } else {
        // notification 和 message的初始化方式不同
        if (strategy[opt.level] === _notification2.default) {
          strategy[opt.level][opt.type]({
            message: opt.title || '提示',
            description: opt.content,
            btn: opt.btn,
            icon: opt.icon,
            key: opt.key,
            onClose: opt.onClose,
            duration: opt.duration
          });
        } else {
          strategy[opt.level][opt.type](opt.content, opt.duration);
        }
      }
    }
  }], [{
    key: 'notifierFactory',
    value: function notifierFactory(type, title, content) {
      return new Notifier({
        level: 'two',
        type: type,
        title: title || '错误异常',
        content: content,
        trace: true
      });
    }
  }, {
    key: 'error',
    value: function error(title, content) {
      if (content) {
        return new Notifier({
          type: 'error',
          level: 'two',
          title: title,
          content: content
        }, 1);
      } else {
        return new Notifier({
          type: 'error',
          level: 'one',
          content: title
        }, 1);
      }
    }
  }, {
    key: 'success',
    value: function success(title, content) {
      if (content) {
        return new Notifier({
          type: 'success',
          level: 'two',
          title: title,
          content: content
        }, 1);
      } else {
        return new Notifier({
          type: 'success',
          level: 'one',
          content: title
        }, 1);
      }
    }
  }, {
    key: 'info',
    value: function info(title, content) {
      if (content) {
        return new Notifier({
          type: 'info',
          level: 'two',
          title: title,
          content: content
        }, 1);
      } else {
        return new Notifier({
          type: 'info',
          level: 'one',
          content: title
        }, 1);
      }
    }
  }, {
    key: 'warn',
    value: function warn(title, content) {
      if (content) {
        return new Notifier({
          type: 'warn',
          level: 'two',
          title: title,
          content: content
        }, 1);
      } else {
        return new Notifier({
          type: 'warn',
          level: 'one',
          content: title
        }, 1);
      }
    }
  }]);

  return Notifier;
}(), _class.strategy = {
  one: _message2.default,
  two: _notification2.default,
  three: seniorNotification
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/components/notifier/notifier.js
// module id = 23
// module chunks = 0